import AttendApplicationApprovalPage from './AttendApplicationApprovalPage'

export default AttendApplicationApprovalPage